<template>
    <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gereciamento Tipo Desconto</span>
                <br/>
                <span class="navigation">Tipo Desconto > Cadastro</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">
            <div>
              <template v-if="validation.hasError('tipoDesconto.nome')">
                <InlineMessage>{{ validation.firstError('tipoDesconto.nome') }}</InlineMessage>
              </template>
            </div>
            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="nome">Nome:</label>
                <span class="p-fluid">
                  <InputText
                    type="text"
                    id="marca"
                    v-model="tipoDesconto.nome"
                    :class="{'p-error': validation.hasError('tipoDesconto.nome')}"
                  />
                </span>
              </div>
            </div>
            <hr />
            <template>
              <Button
                label="Gravar"
                title="Gravar"
                type="submit"
                class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check"
                :disabled="loading"
              >
              </Button>
              <router-link to="/tipoDescontoConsulta">
                <Button
                  label="Voltar"
                  title="Voltar"
                  type="button"
                  class="p-button-primary mr-2"
                  icon="pi pi-arrow-left"
                  :disabled="loading"
                ></Button>
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginService from "../services/acesso/login.service";
import TipoDesconto from '../models/obras/TipoDesconto';
import tipoDescontoService from '../services/obras/tipo.desconto.service';
import SimpleVueValidation from "simple-vue-validator";
const Validator = SimpleVueValidation.Validator;

export default {
    name: 'TipoDescontoCadastro',
    data() {
        return{
            loading: false,
            tipoDesconto: new TipoDesconto()
        }
    },
    created(){
        this.currentUser = LoginService.currentUserValue;
        this.id = this.$route.params.idTipoDesconto;

        if(this.id != null){
            setTimeout(async() => {
                await tipoDescontoService.getTipoDesconto(this.id).then(
                    response=>{
                        this.tipoDesconto = response.data;
                    },
                    error=>{
                        let errorMessage = "Houve um problema ao buscar Tipo Desconto!";
                        if(error.response){
                            errorMessage = error.response.data;
                        }
                        this.$toast.add({
                            severity: "error",
                            summary: errorMessage
                        });
                    }
                )
            },250)
        }
    },
    validators: {
        "tipoDesconto.nome": function(value){
            return Validator.value(value)
            .required("Nome Obrigatório")
            .maxLength(200, "Deve ser menor ou igual a 200")
        }
    },
    methods:{
        onSubmit(){
            this.loading = true;
            this.$validate().then(success => {
                if(success){
                    this.salvar();
                }
            });
            this.loading = false;
        },
        salvar(){
            this.tipoDesconto.idCliente = this.currentUser.usuario.idCliente;
            tipoDescontoService.saveTipoDesconto(this.tipoDesconto).then(
                data => {
                    console.log(data);
                    this.$toast.add({
                        severity: "success",
                        summary: "Tipo Desconto salvo com sucesso"
                    });
                    this.$router.push("tipoDescontoConsulta");
                },
                error => {
                    let errorMessage = "Houve um erro ao salvar o Tipo Desconto!";
                    if(error.response){
                        errorMessage = error.response.data;
                    }
                    this.$toast.add({
                        severity: "error",
                        summary: errorMessage
                    });
                }
            )
        },
        limparForm(){
            this.tipoDesconto.nome = '';
        }
    }
}
</script>